import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { AdminService } from '../../_services/admin.service';
import { Log } from 'ng2-logger';
import { ActivatedRoute, Router } from '@angular/router';
import { Sensor } from '../../_models/sensor';
import { environment } from '../../../environments/environment';
import { ACLFeature } from '../../_models/acl-feature';

const log = Log.create('SensorDetail');

@Component({
  moduleId: module.id,
  selector: 'edit-sensor',
  styleUrls: ['sensor.less'],
  templateUrl: 'sensor.component.html',
})
export class SensorComponent implements OnInit {
  sensor: Sensor = new Sensor;
  BASE_URL: string = environment.BASE_URL;
  possibleCapabilities: any;
  selectedAccessory: object;
  selectedAccessoryMandatory: boolean = false;
  availableAccessories: Array<any> = [];
  selectedAccessories: Array<any> = [];
  allAccessories: Array<any> = [];

  piPoDates: Array<any> = [];

  possibleApplications: any;
  possibleFeatures: any;
  possibleTechnologies: any;

  iCanMaintenanceMode: boolean = false;
  readOnly: boolean = true;
  iCanArchive: boolean = false;
  iCanViewArchive: boolean = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private admin: AdminService,
              private toast: ToastsManager) {}

  ngOnInit() {

    this.admin.canI(ACLFeature.WRITE_SENSORS).subscribe((iCan: boolean) => {
        this.readOnly = !iCan;
    });

    // get sensor controller data
    this.route.params.subscribe(params => {
      this.admin.getSensorController(params['id']).subscribe((response) => {
        this.sensor = response.data;
        response.data.accessories.forEach(accessory => {
          const mandatory = accessory.mandatory;
          const toAddAccessory = {id: accessory.sensorAccessory.id , text: accessory.sensorAccessory.name};
          this.selectedAccessories.push( {mandatory: mandatory, accessory: toAddAccessory});
        });
        log.d('getSensorController response', response);
      });

      this.admin.getSensorApplications().subscribe((res) => {
        this.possibleApplications = res.data;
      });

      this.admin.getSensorFeatures().subscribe((res) => {
        this.possibleFeatures = res.data;
      });

      this.admin.getSensorTechnologies().subscribe((res) => {
        this.possibleTechnologies = res.data;
      });
    });

    this.admin.drilldown('sensor-accessories', null).subscribe((response) => {
       this.allAccessories = response.products;
       this.availableAccessories = response.products.map(accessory => {
         return {
           id: accessory.id,
           text: accessory.name
         };
       });
    });
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this.sensor[input.model] = input.updatedData;
  }

  private onCancel() {
    this.router.navigate(['/drilldown/sensors']);
  }

  private onSubmit() {
    log.d('onSubmit fired');

    this.piPoDates.map((piPoDate) => {
      this.sensor[piPoDate.model] = piPoDate.updatedDate;
    });

    this.sensor.accessories = this.selectedAccessories.map(accessory => {

      const existingAccessory = this.sensor.accessories.find(x => x.sensorAccessory.id === accessory.accessory.id);
      if (existingAccessory) {
        if (existingAccessory.mandatory === accessory.mandatory) {
          return existingAccessory;
        }
      }

      return {
        id: null,
        mandatory: accessory.mandatory,
        sensorAccessory: this.allAccessories.find(x => x.id === accessory.accessory.id)
      };
    });

    this.admin.postSensorController(this.sensor.id, this.sensor).subscribe((response) => {
      this.toast.success(`Changes have been saved.`);
      log.d('postSensorController', 'post succesfull', response);

      this.router.navigate(['/drilldown/sensors', {refresh: Date.now()}]);
    });
  }

  private addAccessory() {
    if (this.selectedAccessory) {
      let exist = false;
      this.selectedAccessories.forEach(item => {
        if (item.accessory.id === this.selectedAccessory[0].id) {
          exist = true;
          return;
        }
      });

      if (!exist) {
        this.selectedAccessories.push({
          accessory: this.selectedAccessory[0],
          mandatory: this.selectedAccessoryMandatory
        });
        this.selectedAccessoryMandatory = false;
      }
    }
  }

  private removeAccessory(index) {
    this.selectedAccessories.splice(index , 1);
  }

  private updatePiPoModel(input) {
    const newDate = new Date(input.updatedData);

    if (!isNaN(newDate.getTime()) || input.updatedData === '') {
      const piPoIndex = this.piPoDates.findIndex(x => x.model === input.model);
      if (piPoIndex !== -1) {
        this.piPoDates[piPoIndex] = {model: input.model, updatedDate: input.updatedData};
      } else {
        this.piPoDates.push({model: input.model, updatedDate: input.updatedData});
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sensors/sensor/sensor.component.ts